/**
* Solution Callout JS
* -----------------------------------------------------------------------------
*
* All the JS for the Solution Callout component.
*/

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );

import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

( function( app ) {
  const COMPONENT = {

    className: 'solution-callout',
    selector: function() {
      return '.' + this.className;
    },

    init: function() {
      if ( $( '.top__splide' ).length ) {
        $( '.top__splide' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: false,
            focus: 'center',
            perPage: 1,
            gap: `12px`,
            autoWidth: true,
            arrows: false,
            pagination: false,
            autoScroll: {
              speed: .35,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );
          slider.mount( {AutoScroll} );
        } );
      }

      if ( $( '.bottom__splide' ).length ) {
        $( '.bottom__splide' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: false,
            focus: 'center',
            perPage: 1,
            gap: `12px`,
            autoWidth: true,
            arrows: false,
            pagination: false,
            direction: 'rtl',
            autoScroll: {
              speed: .35,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );
          slider.mount( {AutoScroll} );
        } );
      }

      const component = document.querySelector( '.solution-callout' );
      if ( component ) {
        const lines = component.querySelectorAll( '.solution-callout__draw' );
        const circles = component.querySelectorAll( '.solution-callout__circle' );

        gsap.set( lines, {
          scaleX: 0,
          transformOrigin: '100% 50%',
        } );

        gsap.set( circles, {
          scale: 0,
          transformOrigin: 'center center',
        } );

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: component,
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        } );

        lines.forEach( ( line, i ) => {
          tl.to( line, {
            scaleX: 1,
            duration: 1,
            ease: 'power2.out',
          }, i * 0.6 )
              .to( circles[i], {
                scale: 1,
                duration: 0.3,
                ease: 'back.out(1.7)',
              }, i * 0.6 + 1 );
        } );
      }
    },

    finalize: function() {},
  };

  app.registerComponent( 'solution-callout', COMPONENT );
} )( app );
